import React from 'react'
import { Box, Typography } from '@mui/material'
import EventAvailableIcon from '@mui/icons-material/EventAvailable'
import rgfoLogo from '../../../../assets/images/RockefellerGlobalFamilyOffice.png'

interface BookingHeaderProps {
  title: string
  subtitle?: string
}

// Deep-teal branded header shared by the intro and booking screens: the Rockefeller Global Family
// Office wordmark (rendered white over teal), a divider, then the calendar mark + screen title.
const BookingHeader: React.FC<BookingHeaderProps> = ({ title, subtitle }) => (
  <Box sx={{ bgcolor: '#002A3A', px: { xs: 3, sm: 4 }, pt: 3.5, pb: 3.25 }}>
    <Box sx={{ textAlign: 'center', pb: 2.5, borderBottom: '1px solid rgba(180,157,119,0.28)' }}>
      <Box
        component="img"
        src={rgfoLogo}
        alt="Rockefeller Global Family Office"
        sx={{ display: 'inline-block', height: 34, width: 'auto', maxWidth: '100%', filter: 'brightness(0) invert(1)' }}
      />
    </Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.9, mt: 2.75 }}>
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: '12px',
          bgcolor: 'rgba(180,157,119,0.16)',
          border: '1px solid rgba(180,157,119,0.35)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0
        }}
      >
        <EventAvailableIcon sx={{ fontSize: 23, color: '#B49D77' }} />
      </Box>
      <Typography sx={{ fontWeight: 600, fontSize: '1.55rem', lineHeight: 1.1, color: '#F3F1EC', letterSpacing: '-0.01em' }}>
        {title}
      </Typography>
    </Box>
    {subtitle && (
      <Typography sx={{ mt: 2, fontWeight: 300, fontSize: '0.95rem', lineHeight: 1.5, color: 'rgba(243,241,236,0.82)' }}>
        {subtitle}
      </Typography>
    )}
  </Box>
)

export default BookingHeader
